import React from "react";
import { message, Input, Button } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { getData,getKCISData } from "../services/index";
import $ from 'jquery';

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      loading: false,
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { oldPassword, newPassword, confirmPassword } = this.state;

    if (!oldPassword || !newPassword || !confirmPassword) {
      message.error("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      message.error("Passwords do not match.");
      return;
    }

    getKCISData("auth/admin_verify_password", { oldPassword })
      .then((result) => {
        let responseJson = result;
			if (result["status"] == 200) {
            this.setState({ loading: true });
            const data = {
              oldPassword,
              newPassword,
            };
            getKCISData("auth/admin_change_password", data)
              .then((result) => {
                let responseJson = result;
                  if (result["status"] == 200) {
                    message.success("Password changed successfully.");
                    this.setState({
                      oldPassword: "",
                      newPassword: "",
                      confirmPassword: "",
                      loading: false,
                    });
					this.logout();
                  } else {
                    message.error(
                      result.message || "Failed to change password.",
                    );
                    this.setState({ loading: false });
                  }
              })
              .catch((error) => {
                console.error("Error:", error);
                message.error("An error occurred while changing the password.");
                this.setState({ loading: false });
              });
			} else {
            //message.error("Old password verification failed.");
				message.error("Old password verification failed.");
			}
		})
		.catch((error) => {
        console.error("Error:", error);
        message.error("An error occurred during old password verification.");
		});
	};
	
	logout(){
		localStorage.setItem("schoolData",'');
		localStorage.clear();
		window.location.href = '/login/';
	}
	
	showNew(type){
		if(type == 'new'){
			$("#new_pass_icon").toggleClass("fa-eye fa-eye-slash");
			var input = $("#new_pass").attr("type");
			if (input == "password") {
				$("#new_pass").attr("type", "text");
			} else {
				$("#new_pass").attr("type", "password");
			}
		}else if(type == 'confirm'){
			$("#conf_pass_icon").toggleClass("fa-eye fa-eye-slash");
			var input = $("#conf_pass").attr("type");
			if (input == "password") {
				$("#conf_pass").attr("type", "text");
			} else {
				$("#conf_pass").attr("type", "password");
			}
		}else if(type == 'old'){
			$("#old_pass_icon").toggleClass("fa-eye fa-eye-slash");
			var input = $("#old_pass").attr("type");
			if (input == "password") {
				$("#old_pass").attr("type", "text");
			} else {
				$("#old_pass").attr("type", "password");
			}
		}
		
	}


  render() {
    const { oldPassword, newPassword, confirmPassword, loading } = this.state;

    return (
      <div className="content-body">
        <div className="row justify-content-center">
          <div className="col-md-6 col-6">
            <div className="card">
              <div className="card-content">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label className="control-label">Old Password</label>
                      <Input
                        type="password"
                        name="oldPassword"
                        value={oldPassword}
						id="old_pass"
                        onChange={this.handleInputChange}
                        placeholder="Old Password"
                      />
					  <span toggle="#password-field" id="old_pass_icon" class="fa fa-fw fa-eye field-icon toggle-password" onClick={this.showNew.bind(this,'old')}></span>
                    </div>

                    <div className="form-group">
                      <label className="control-label">New Password</label>
                      <Input
                        type="password"
                        name="newPassword"
                        value={newPassword}
						id="new_pass"
                        onChange={this.handleInputChange}
                        placeholder="New Password"
                      />
					  <span toggle="#password-field" id="new_pass_icon" class="fa fa-fw fa-eye field-icon toggle-password" onClick={this.showNew.bind(this,'new')}></span>
                    </div>

                    <div className="form-group">
                      <label className="control-label">Confirm Password</label>
                      <Input
                        type="password"
                        name="confirmPassword"
						id="conf_pass"
                        value={confirmPassword}
                        onChange={this.handleInputChange}
                        placeholder="Confirm Password"
                      />
					  <span toggle="#password-field" id="conf_pass_icon" class="fa fa-fw fa-eye field-icon toggle-password" onClick={this.showNew.bind(this,'confirm')}></span>
                    </div>

                    <Button type="primary" htmlType="submit" loading={loading}>
                      Save Changes
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChangePassword;
